import React, {FC} from 'react';
import styled from 'styled-components';

import {VisualSizesEnum} from '../../styles/commonStyles';
import {TextArea, TextAreaInheritableProps, TextAreaProps} from '../inputs/textarea';
import {BoxedInputChildProps, boxedInputColors, inputContentStyles} from './boxedInputConstants';

/*
 * Props.
 */

export type BoxedTextAreaElementInheritableProps = TextAreaInheritableProps;
export type BoxedTextAreaElementProps = TextAreaProps &
  BoxedInputChildProps & {
    textAreaRef?: React.RefObject<React.ElementRef<typeof TextArea>>;
  };

/*
 * Style.
 */

interface TextAreatStyleProps {
  $size: VisualSizesEnum;
}

const StyledTextArea = styled(TextArea)<TextAreatStyleProps>`
  flex: 1;
  width: 0;
  overflow: hidden;

  ${(p) => inputContentStyles[p.$size]};

  &::placeholder {
    color: ${boxedInputColors.textPlaceholder};
  }
`;

/*
 * Component.
 */

export const BoxedTextAreaElement: FC<BoxedTextAreaElementProps> = (props) => (
  <StyledTextArea $size={props.size} ref={props.textAreaRef} {...props} />
);
